import { render, staticRenderFns } from "./epidemicNotice.vue?vue&type=template&id=d2dd99b0&scoped=true&"
import script from "./epidemicNotice.vue?vue&type=script&lang=js&"
export * from "./epidemicNotice.vue?vue&type=script&lang=js&"
import style0 from "./epidemicNotice.vue?vue&type=style&index=0&id=d2dd99b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd99b0",
  null
  
)

export default component.exports